import { z } from 'zod';

export const RegisterVehicleComponentBodySchema = z.object({
  vehicleComponentTypeId: z.uuid(),
  confirmDuplicate: z.boolean().optional(),
});

export type RegisterVehicleComponentBody = z.infer<typeof RegisterVehicleComponentBodySchema>;

export const UpdateVehicleComponentBodySchema = z.object({
  vehicleComponentTypeId: z.uuid().optional(),
  confirmDuplicate: z.boolean().optional(),
});

export type UpdateVehicleComponentBody = z.infer<typeof UpdateVehicleComponentBodySchema>;

export const DeleteVehicleComponentBodySchema = z.object({
  deleteReason: z.string().trim().optional(),
});

export type DeleteVehicleComponentBody = z.infer<typeof DeleteVehicleComponentBodySchema>;

export const VehicleComponentResponseSchema = z.object({
  id: z.uuid(),
  partyId: z.uuid(),
  customerVehicleId: z.uuid(),
  vehicleComponentTypeId: z.uuid(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type VehicleComponentResponse = z.infer<typeof VehicleComponentResponseSchema>;

export const ListVehicleComponentsResponseSchema = z.object({
  items: z.array(VehicleComponentResponseSchema),
});

export type ListVehicleComponentsResponse = z.infer<typeof ListVehicleComponentsResponseSchema>;

export const RegisterVehicleComponentResponseSchema = z.object({
  componentId: z.uuid(),
});

export type RegisterVehicleComponentResponse = z.infer<
  typeof RegisterVehicleComponentResponseSchema
>;

export const UpdateVehicleComponentResponseSchema = z.object({
  componentId: z.uuid(),
  changedFields: z.array(z.string()),
});

export type UpdateVehicleComponentResponse = z.infer<typeof UpdateVehicleComponentResponseSchema>;

export const VehicleComponentTypeSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
});

export type VehicleComponentType = z.infer<typeof VehicleComponentTypeSchema>;

export const ListVehicleComponentTypesResponseSchema = z.object({
  items: z.array(VehicleComponentTypeSchema),
});

export type ListVehicleComponentTypesResponse = z.infer<
  typeof ListVehicleComponentTypesResponseSchema
>;
